import React, { useMemo } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Topbar } from "./Topbar";
import { AnimateLoading } from "../../../_partials/controls";
import { useSelector } from "react-redux";

export function Header() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      ),
    };
  }, [uiService]);
  const { isEmployee } = useSelector(({ auth }) => ({
    isEmployee: auth.user?.roles?.includes(2),
  }));
  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div
          className={` ${
            layoutProps.headerContainerClasses
          } d-flex align-items-stretch ${
            isEmployee ? "justify-content-between" : "justify-content-end"
          } `}
        >
          <AnimateLoading />
          {/*begin::Header Menu Wrapper*/}

          {!layoutProps.menuHeaderDisplay && <div />}
          {/*end::Header Menu Wrapper*/}
          {isEmployee && <div className="custom-logo"></div>}
          {/*begin::Topbar*/}
          <Topbar />
          {/*end::Topbar*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
